import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import { Card } from "./Card";
import { F, T } from "../../theme/tokens";

export function KpiCard({ icon, label, value, sub, trend, trendUp }: { icon: React.ReactNode; label: string; value: string; sub?: string; trend?: string; trendUp?: boolean }) {
  return (
    <Card className="kpi-card" style={{ padding: "20px 22px" }}>
      <div className="kpi-head" style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: "14px" }}>
        <div className="kpi-icon" style={{ width: 36, height: 36, borderRadius: "8px", background: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center", color: T.sub }}>
          {icon}
        </div>
        {trend && (
          <span className="kpi-trend" style={{ display: "flex", alignItems: "center", gap: "3px", fontSize: "11px", fontWeight: 600, color: trendUp ? "#166534" : "#991b1b", fontFamily: F }}>
            {trendUp ? <ArrowUpRight size={13} /> : <ArrowDownRight size={13} />} {trend}
          </span>
        )}
      </div>
      <p className="kpi-value" style={{ fontSize: "24px", fontWeight: 700, color: T.text, fontFamily: F, letterSpacing: "-0.03em", lineHeight: 1 }}>{value}</p>
      <p className="kpi-label" style={{ fontSize: "12px", color: T.sub, fontFamily: F, marginTop: "5px" }}>{label}</p>
      {sub && <p className="kpi-sub" style={{ fontSize: "11px", color: T.muted, fontFamily: F, marginTop: "2px" }}>{sub}</p>}
    </Card>
  );
}
